import React, { useEffect, useState } from 'react';
import Page from '../../../page';
import SolutionHeader from '../../SolutionHeader/SolutionHeader';
import { useDispatch, useSelector } from 'react-redux';
import { setScreen } from '../../../../redux/connectedComponent/uiFactory/uiFactory.slice';
import { screens } from '../../../config/uiFactory.config';
import {
  StepContainer,
  StepLabelContainer,
  StepPrimaryLabel,
  StepSecondaryLabel,
  StepIcon,
  Step,
  StepConnector,
  StepProgressBar,
  StepWrapper,
  StepContent,
  Button,
  IconChevronRight,
  IconChevronLeft,
  BUTTON_VARIANTS,
  TOAST_POSITIONS,
  TOAST_VARIANTS,
  TOAST_VISIBILITY_DURATIONS,
  MultiToasts,
} from 'cdk-radial';
import './EditVerticalScoping.scss';
import LocationSelector from './sub-components/LocationSelector';
import { getDMSInfoBasedOnApis } from '../../../../redux/connectedComponent/selectedDMS/selectedDMS.slice';
import ManageFields from './sub-components/ManageFields';
import ReviewFields from './sub-components/ReviewFields';
import {
  updateSaveComplete,
  clearState,
  getSubscriptionFields,
  updateSubscriptionFields
} from '../../../../redux/connectedComponent/apiFields/apiFields.slice';
import { isEqualIgnoreOrder } from '../../../../utils/utils';
import { Loading } from '../../../loader/Loading';
import styled from 'styled-components';
import {getOverlappingFields} from '../../../../utils/fieldsProcessing';
import { trackPageView } from '../../../../utils/gtm';

const _ = require('lodash');

const API_ID_PREFIX = 'api-v2-';
export default function EditVerticalScopingContainer({
  solutionData,
  additionalData: { subscriptionData, isAppNotListed, isBulkSubscribed },
}) {
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = useState(1);
  const {
    selectedLocation,
    saveComplete,
    currentFieldSelection,
    updatedFieldSelection,
    fetchingSubscriptionFields,
    failedToFetchSubscriptionFields,
    failedToSaveSubscriptionFields,
    prevLocation,
    isvFields,
  } = useSelector((state) => state?.apiFieldsSlice);
  const { verticalScopingApisList, getDMSInfoBasedOnApisPending } = useSelector(
    (state) => state?.selectDMSSlice
  );
  const token = useSelector(
    (state) => state?.loginDetailsSlice?.authenticationToken
  );
  const allLocations = useSelector(
    (state) => state?.loginDetailsSlice?.allLocations
  );
  const isLastStep = Boolean(activeStep === 3);
  const steps = [
    {
      label: 'Step 1',
      secondary_label: 'Select Location',
    },
    {
      label: 'Step 2',
      secondary_label: 'Edit API Fields',
    },
    {
      label: 'Step 3',
      secondary_label: 'Review and save',
    },
  ];
  const [toasts, setToasts] = useState([]);
  const addToast = (toast) => setToasts((prev) => [toast, ...prev]);
  const removeToast = (id) =>
    setToasts((prev) => prev.filter((toast) => toast.id !== id));

  const LoadingWrapper = styled.div`
    width: 100%;
  `;
  const ErrorWrapper = styled.div`
    text-align: center;
  `;

  function onBackButtonClick() {
    dispatch(clearState());
    dispatch(setScreen({ screen: screens.SUBSCRIPTION_MANAGEMENT }));
  }

  const prevButtonHandler = () => {
    if (activeStep === 1) onBackButtonClick();
    else setActiveStep(activeStep - 1);
  };

  /**
   * Computes API field changes for subscription update
   * Extracts shared logic between bulk and non-bulk paths
   */
  const computeApiFieldsChanges = (apiDetailsMap) => {
    const apiIds = Object.keys(updatedFieldSelection);
    const updatedAPIList = [];
    const updatedFields = {};

    apiIds.forEach((apiId) => {
      if (
        !isEqualIgnoreOrder(
          currentFieldSelection[apiId],
          updatedFieldSelection[apiId],
        )
      ) {
        updatedAPIList.push(apiDetailsMap[apiId]);
      }

      updatedFields[apiId] = getOverlappingFields(
        isvFields[apiId],
        updatedFieldSelection[apiId],
      )?.commonFields;
    });

    return { updatedAPIList, updatedFields };
  };

  /**
   * Builds the API details map for bulk subscribed scenario
   */
  const buildBulkApiDetailsMap = () => {
    const apiDetailsMap = {};

    Array.isArray(solutionData.integrations) &&
      solutionData.integrations.forEach((integration) => {
        const id = integration.apiId;
        const apiName = integration.name;
        if (!apiDetailsMap[id]) {
          apiDetailsMap[id] = {
            id,
            displayName: apiName,
            type: 'api',
          };
        }
      });

    Array.isArray(solutionData.asyncApiIntegrations) &&
      solutionData.asyncApiIntegrations.forEach((integration) => {
        const id = integration.asyncApiId;
        const apiName = integration.name;
        if (!apiDetailsMap[id]) {
          apiDetailsMap[id] = {
            id,
            displayName: apiName,
            type: 'async-api',
          };
        }
      });

    return apiDetailsMap;
  };

  /**
   * Builds the API details map for non-bulk scenario
   */
  const buildNonBulkApiDetailsMap = () => {
    const apiDetailsMap = {};
    solutionData?.registration_details?.api_details?.forEach((api) => {
      const { id: apiId, displayName, apiType } = api;
      const id = apiId.replace(API_ID_PREFIX, '');
      if (!apiDetailsMap[id]) {
        apiDetailsMap[id] = {
          id,
          displayName,
          type: apiType,
        };
      }
    });
    return apiDetailsMap;
  };

  const isNextDisabled = () =>{
    if(activeStep === 1) 
      return !selectedLocation
    if(activeStep === 2)
      return isEqualIgnoreOrder(currentFieldSelection, updatedFieldSelection) ||  toasts.length
    return false
  }

  const nextButtonHandler = () => {
    if (activeStep === 1 && selectedLocation !== prevLocation) {
      dispatch(
        getSubscriptionFields({
          solutionId: solutionData?.id,
          entityId: selectedLocation,
          token,
          isBulkSubscribed
        })
      );
      setToasts([])
    }
    if (isLastStep) {
      const currentLocation = Array.isArray(allLocations)
        ? allLocations.find(
            (location) => location.entityId === selectedLocation,
          )
        : null;

      let subscription = subscriptionData.find(
        (entity) => entity.entityId === selectedLocation
      );

      if (isBulkSubscribed && solutionData?.isAppNotListed) {
        const apiDetailsMap = buildBulkApiDetailsMap();
        const { updatedAPIList, updatedFields } = computeApiFieldsChanges(apiDetailsMap);

        dispatch(
          updateSubscriptionFields({
            solutionId: solutionData?.id,
            apiFieldSelections: {
              [selectedLocation]: updatedFields,
            },
            solutionData: {
              appName: solutionData?.name,
              subscriptionNotificationEmail: solutionData?.developerEmail,
              solutionOrgId: solutionData.entityId,
            },
            subscriptionDetails: {
              subscriptionId: subscription.subscriptionId,
              dealerName: currentLocation?.partyName,
            },
            updatedAPIList: updatedAPIList,
            token,
            isBulkSubscribed: true,
          }),
        );
      } else {
        const apiDetailsMap = buildNonBulkApiDetailsMap();
        const { updatedAPIList, updatedFields } = computeApiFieldsChanges(apiDetailsMap);

        dispatch(
          updateSubscriptionFields({
            solutionId: solutionData?.id,
            apiFieldSelections: {
              [selectedLocation]: updatedFields,
            },
            solutionData: {
              appName: solutionData.overview.name,
              subscriptionNotificationEmail:
                solutionData.subscription_notifications.email,
              solutionOrgId: solutionData.entityId,
            },
            subscriptionDetails: {
              subscriptionId: subscription.subscriptionId,
              dealerName:
                subscription?.entityIdList?.[0]?.location ||
                currentLocation?.partyName,
            },
            updatedAPIList: updatedAPIList,
            token,
            isBulkSubscribed: isBulkSubscribed ? true : false
          }),
        );
      }
    } else setActiveStep(activeStep + 1);
  };

  const EditMoreLocationHandler = () => {
    dispatch(updateSaveComplete({ status: false }));
    setActiveStep(1);
  };

  useEffect(() => {
    trackPageView('Manage Field Filtering');
    dispatch(clearState());
  }, []);

  useEffect(() => {
    if (isBulkSubscribed && solutionData?.isAppNotListed) {
      const apiList = [];
      Array.isArray(solutionData.apiProducts) &&
        solutionData.apiProducts.forEach((api) => {
          apiList.push({ apiType: 'api', id: api });
        });

      Array.isArray(solutionData.asyncApiIntegrations) &&
        solutionData.asyncApiIntegrations.forEach((item) => {
          apiList.push({ apiType: 'async-api', id: item.asyncApiId });
        });

      dispatch(
        getDMSInfoBasedOnApis({
          apis: apiList,
          token: token,
          appId: solutionData?.id,
        }),
      );
    } else {
      const apis = solutionData?.registration_details?.api_details?.map(
        (api) => ({ id: api?.id, apiType: api?.apiType }),
      );
      dispatch(
        getDMSInfoBasedOnApis({ apis, token: token, appId: solutionData?.id }),
      );
    }
  }, [solutionData]);

  useEffect(() => {
    if (saveComplete) {
      let result = {}
      for (const api in currentFieldSelection) {
        let disabledCount = 0;
        let disabledField = '';
        currentFieldSelection[api].forEach((field) => {
          if (!updatedFieldSelection[api].includes(field)) {
            disabledCount += 1;
            disabledField = field;
          }
        });
        result[api] = {disabledCount,disabledField}
      }

      for (const api in updatedFieldSelection) {
        let enabledCount = 0;
        let enabledField = '';
         updatedFieldSelection[api]
          .forEach((field) => {
            if (
              !currentFieldSelection[api] ||
              !currentFieldSelection[api]?.includes(field)
            ) {
              enabledCount += 1;
              enabledField = field;
            }
          })
          if(result[api])
            result[api] = {...result[api],enabledCount,enabledField}
          else
          result[api] = {enabledCount,enabledField}         
      }

      for(const api in result){
        const {disabledCount, disabledField, enabledCount, enabledField } = result[api];
        if( disabledCount || enabledCount) {
          const apiInfo = verticalScopingApisList.filter(
            (vsApi) => vsApi.id === api
          );
          let toastMessage = '';
          if (disabledCount && enabledCount)
            toastMessage = `You have disabled ${disabledCount} ${
              disabledCount > 1 ? 'fields' : 'field'
            } and enabled  ${enabledCount} ${
              enabledCount > 1 ? 'fields' : 'field'
            } for ${apiInfo[0]?.name} API`;
          else if (disabledCount)
            toastMessage = `You have disabled ${disabledField} ${
              disabledCount > 1
                ? `and ${disabledCount - 1} other fields`
                : 'field'
            } for ${apiInfo[0]?.name} API`;
          else if (enabledCount)
            toastMessage = `You have enabled ${enabledField} ${
              enabledCount > 1
                ? `and ${enabledCount - 1} other fields`
                : 'field'
            } for ${apiInfo[0]?.name} API`;

          addToast({
            actions: [
              {
                onClick: () => removeToast(api),
                text: 'Dismiss',
              },
            ],
            content: toastMessage,
            id: api,
            onVisibilityDurationEnd: () => {
              removeToast(api);
            },
            variant: TOAST_VARIANTS.POSITIVE,
            visibilityDuration: TOAST_VISIBILITY_DURATIONS.SEVEN_SECONDS,
            style: {
              maxWidth: '500px !important',
            },
          });
        }
      }
    }
  }, [saveComplete]);
  return (
    <Page HideAppManagementText={true}>
      <SolutionHeader
        solutionData={solutionData}
        onBackButtonClickHandler={onBackButtonClick}
        appName={solutionData?.displayName}
        publisherName={solutionData?.orgName}
        isAppNotListed={isAppNotListed}
      />
      {failedToFetchSubscriptionFields || failedToSaveSubscriptionFields ? (
        <ErrorWrapper>
          <h1>Something went wrong.</h1>
          <h2>Please contact Fortellis Support at support@fortellis.io</h2>
        </ErrorWrapper>
      ) : (
        <>
          {getDMSInfoBasedOnApisPending ? (
            <LoadingWrapper>
              {' '}
              <Loading label={'Fetching App details ...'} />{' '}
            </LoadingWrapper>
          ) : verticalScopingApisList?.length ? (
            <div className="edit-vs-stepper-container">
              <StepContainer data-testid="stepper">
                <StepWrapper>
                  {steps.map((step, i) => {
                    const index = i + 1;
                    const isLastStep = index === steps.length;
                    return (
                      <React.Fragment key={index}>
                        <Step
                          isActive={saveComplete ? false : activeStep === index}
                          isComplete={saveComplete ? false : activeStep > index}
                          onClick={() => setActiveStep(index)}
                          aria-labelledby={`label${index}`}
                          aria-disabled={activeStep < index}
                          data-testid={`step-${index}`}
                          className="verticalScoping-stepper-step"
                        >
                          <StepIcon
                            dataTestId={`step-${index}-icon`}
                            stepNumber={index}
                          />
                          <StepLabelContainer>
                            <StepPrimaryLabel
                              data-testid={`step-${index}-primary-label`}
                              id={`label${index}`}
                            >
                              {step.label}
                            </StepPrimaryLabel>
                            <StepSecondaryLabel
                              data-testid={`step-${index}-secondary-label`}
                            >
                              {step.secondary_label}
                            </StepSecondaryLabel>
                          </StepLabelContainer>
                        </Step>
                        {!isLastStep && <StepConnector aria-hidden="true" />}
                      </React.Fragment>
                    );
                  })}
                </StepWrapper>
                <StepProgressBar
                  totalSteps={3}
                  currentStep={activeStep}
                ></StepProgressBar>
              </StepContainer>
              {activeStep === 1 && (
                <StepContent
                  className="edit-fields-locations-step"
                  data-testid="edit-fields-locations-step"
                >
                  {' '}
                  <LocationSelector
                    subscribedLocations={subscriptionData}
                    isBulkSubscribed={isBulkSubscribed}
                  />{' '}
                </StepContent>
              )}
              {activeStep === 2 && (
                <StepContent className="edit-fields-locations-step">
                  {' '}
                  {fetchingSubscriptionFields ? (
                    <LoadingWrapper>
                      {' '}
                      <Loading label={'Fetching Fields...'} />{' '}
                    </LoadingWrapper>
                  ) : (
                    <ManageFields
                      addToast={addToast}
                      removeToast={removeToast}
                    />
                  )}
                </StepContent>
              )}
              {activeStep === 3 && (
                <StepContent className="edit-fields-locations-step">
                  {' '}
                  <ReviewFields />{' '}
                </StepContent>
              )}

              {saveComplete ? (
                <div className="edit-fields-footer">
                  <Button
                    onClick={onBackButtonClick}
                    text="Back to App Management"
                    icon={
                      <IconChevronLeft
                        focusable={false}
                        height={12}
                        role="presentation"
                        viewBox="0 0 24 24"
                        width={12}
                      />
                    }
                    variant={BUTTON_VARIANTS.SECONDARY}
                    dataTestId="app-mgmt-btn"
                  />
                  <Button
                    onClick={EditMoreLocationHandler}
                    text="Edit Another Location"
                    backgroundAppearance="light"
                    preserveClickableArea={false}
                    size="standard"
                    variant={BUTTON_VARIANTS.PRIMARY}
                    dataTestId="manage-vs-edit-location-btn"
                  />
                </div>
              ) : (
                <div className="edit-fields-footer">
                  <Button
                    onClick={prevButtonHandler}
                    text="Previous"
                    icon={
                      <IconChevronLeft
                        focusable={false}
                        height={12}
                        role="presentation"
                        viewBox="0 0 24 24"
                        width={12}
                      />
                    }
                    variant={BUTTON_VARIANTS.SECONDARY}
                    dataTestId="manage-vs-prev-btn"
                  />
                  <Button
                    onClick={nextButtonHandler}
                    isDisabled={isNextDisabled()}
                    text={isLastStep ? 'Save' : 'Next'}
                    backgroundAppearance="light"
                    icon={isLastStep ? null : <IconChevronRight />}
                    iconSize={24}
                    isIconTrailing
                    preserveClickableArea={false}
                    size="standard"
                    variant={BUTTON_VARIANTS.PRIMARY}
                    dataTestId="manage-vs-next-btn"
                  />
                </div>
              )}
            </div>
          ) : (
            <div className="edit-vs-fallback-screen">
              This app does not have any APIs that support Field Filtering.
            </div>
          )}
        </>
      )}
      <MultiToasts
        id="multi-toast-id"
        style={{ maxWidth: '500px !important' }}
        items={toasts}
        position={TOAST_POSITIONS.FIXED}
      />
    </Page>
  );
}
